import { useMapPoint } from "hooks/mapHooks";
import { useAppLayoutContext } from "hooks/routingHooks";

import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { PointInfoLinkItem } from "./PointInfoLinkItem";

export function PointInfoLinks() {
  const {
    settings: { pointInfoLinks },
  } = useAppLayoutContext();
  const [point] = useMapPoint();

  if (point && pointInfoLinks.length > 0)
    return (
      <PaddedPaper>
        {point &&
          pointInfoLinks.length > 0 &&
          pointInfoLinks.map((pointInfoLink) => (
            <PointInfoLinkItem
              pointInfoLink={pointInfoLink}
              point={point}
              key={pointInfoLink.id}
            />
          ))}
      </PaddedPaper>
    );
  return null;
}
